export const calculationInitialSortValue = {
	id: "agent_name",
	desc: true,
};
